import clsx from 'clsx'
import styles from './Skeleton.module.scss'

export interface SkeletonProps {
  width?: number | string
  height?: number | string
  circle?: boolean
  className?: string
}

export function Skeleton({ width = '100%', height = 14, circle, className }: SkeletonProps) {
  return <span className={clsx(styles.skeleton, circle && styles.circle, className)} style={{ width, height }} aria-hidden="true" />
}

export function SkeletonRows({ rows = 5, height = 44 }: { rows?: number; height?: number }) {
  return (
    <div className={styles.stack} aria-busy="true" aria-live="polite">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={height} />
      ))}
    </div>
  )
}

export function Spinner({ label, size = 'md', className }: { label?: string; size?: 'sm' | 'md'; className?: string }) {
  if (size === 'sm')
    return <span className={clsx(styles.spinner, styles.spinnerSm, className)} role="status" aria-label={label ?? 'Loading'} />
  return (
    <div className={clsx(styles.spinnerWrap, className)} role="status">
      <span className={styles.spinner} />
      {label && <span>{label}</span>}
    </div>
  )
}
